import React from 'react';
const EventOrganisers = () => <div className="service-page"><h1>Event Organisers</h1><p>Plan your events with the best organisers in town.</p></div>;
export default EventOrganisers;
